import React from 'react';
import LinfinityLogo from './LinfinityLogo';
import equilibriumLogo from './ee-logo-150-pixels.png';

type EntityLogoProps = {
  entity?: string;
  width?: number | string;
  height?: number | string;
  size?: 'icon' | 'small' | 'medium' | 'large' | 'horizontal';
  className?: string;
  style?: React.CSSProperties;
};

function isEquilibriumEntity(entity?: string) {
  return String(entity || '').trim().toLowerCase() === 'equilibrium engineering pty ltd';
}

const EntityLogo: React.FC<EntityLogoProps> = ({
  entity,
  width,
  height,
  size = 'horizontal',
  className = '',
  style = {},
}) => {
  if (isEquilibriumEntity(entity)) {
    return (
      <img
        src={equilibriumLogo}
        alt="Equilibrium Engineering"
        width={width || 300}
        height={height || 96}
        className={className}
        style={{
          objectFit: 'contain',
          ...style,
        }}
      />
    );
  }

  return (
    <LinfinityLogo
      width={width}
      height={height}
      size={size}
      className={className}
      style={style}
    />
  );
};

export default EntityLogo;
